"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _activePortal = require("../activePortal");

var _activatedAlarms = require("./activated-alarms.actions");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _activatedAlarms.FIND_TRIGGERED_ALARMS_REQUEST:
      {
        var widgetId = action.headers.widgetId;

        var _ref = state[widgetId] || {},
            activatedAlarmDetails = _ref.activatedAlarmDetails;

        return Object.assign({}, state, _defineProperty({}, widgetId, {
          activatedAlarmDetails: activatedAlarmDetails,
          activatedAlarms: []
        }));
      }

    case _activatedAlarms.FIND_TRIGGERED_ALARMS_SUCCESS:
      {
        var data = action.body.triggeredAlarms;
        var _widgetId = action.headers.widgetId;
        var widgetData = Object.assign({}, state[_widgetId], {
          activatedAlarms: data
        });
        return Object.assign({}, state, _defineProperty({}, _widgetId, widgetData));
      }

    case _activatedAlarms.FIND_TRIGGERED_ALARMS_ERROR:
      {
        var _widgetId2 = action.headers.widgetId;

        var _widgetData = Object.assign({}, state[_widgetId2], {
          activatedAlarms: []
        });

        return Object.assign({}, state, _defineProperty({}, _widgetId2, _widgetData));
      }

    case _activatedAlarms.FIND_TRIGGERED_ALARM_DETAILS_REQUEST:
      {
        var dynamicPaging = action.body.dynamicPaging;
        var _widgetId3 = action.headers.widgetId;

        if (dynamicPaging.pageNumber > 0) {
          return state;
        }

        var newState = _objectSpread(_objectSpread({}, state[_widgetId3]), {}, {
          activatedAlarmDetails: []
        });

        return _objectSpread(_objectSpread({}, state), _defineProperty({}, _widgetId3, newState));
      }

    case _activatedAlarms.FIND_TRIGGERED_ALARM_DETAILS_SUCCESS:
      {
        var _state$_widgetId4$act, _state$_widgetId4$act2;

        var _data = action.body.triggeredAlarmDetails;
        var _data$events = _data.events,
            events = _data$events === void 0 ? [] : _data$events;
        var _widgetId4 = action.headers.widgetId;
        var oldEvents = (_state$_widgetId4$act = (_state$_widgetId4$act2 = state[_widgetId4].activatedAlarmDetails) === null || _state$_widgetId4$act2 === void 0 ? void 0 : _state$_widgetId4$act2.events) !== null && _state$_widgetId4$act !== void 0 ? _state$_widgetId4$act : [];

        var _newState = _objectSpread(_objectSpread({}, state[_widgetId4]), {}, {
          activatedAlarmDetails: _objectSpread(_objectSpread({}, _data), {}, {
            events: [].concat(_toConsumableArray(oldEvents), _toConsumableArray(events))
          })
        });

        return _objectSpread(_objectSpread({}, state), _defineProperty({}, _widgetId4, _newState));
      }

    case _activatedAlarms.FIND_TRIGGERED_ALARM_DETAILS_ERROR:
      {
        var _widgetId5 = action.headers.widgetId;

        var _newState2 = _objectSpread(_objectSpread({}, state[_widgetId5]), {}, {
          activatedAlarmDetails: undefined
        });

        return _objectSpread(_objectSpread({}, state), _defineProperty({}, _widgetId5, _newState2));
      }

    case _activePortal.CHANGE_ACTIVE_PORTAL:
      return {};

    default:
      {
        return state;
      }
  }
};

exports["default"] = _default;